<form [formGroup]="comercializadorForm" (click)="onFormClick($event)">
    <div *ngIf="loading">Cargando datos...</div>
    <h2>Caracterización canal comercializador</h2>

    <!-- HU 116 - Mensaje cuando la caracterización está bloqueada por estar clasificada -->
    <div *ngIf="caracterizacionBloqueada" class="alerta-bloqueo">
        <i class="pi pi-lock"></i>
        La caracterización de tu empresa ha sido clasificada y no puede ser editada.
        Si requieres realizar cambios, por favor, comunícate con la mesa de ayuda.
    </div>

    <!-- Pregunta 1 -->
    <div class="pregunta-row">
        <p>1. ¿Cuántos puntos de venta tiene la empresa?</p>
        <div *ngIf="registrosPuntosVenta.length > 0; else noPuntosVenta">
            <select
                formControlName="puntosVenta"
                (change)="onPuntosVentaChange($event.target.value)">
                <option *ngFor="let r of registrosPuntosVenta" [value]="r.id">
                    {{ r.nombre }}
                </option>
            </select>
        </div>
        <ng-template #noPuntosVenta>
            <div>.</div>
        </ng-template>
    </div>

    <!-- Pregunta 2 -->
    <div class="pregunta-row">
        <p>2. Estos puntos de venta ¿en cuántos municipios se localizan?</p>
        <div
            *ngIf="
                registrosPuntosVentaMunicipios.length > 0;
                else noPuntosVentaMunicipios
            ">
            <select formControlName="puntosVentaMunicipios">
                <option
                    *ngFor="let r of registrosPuntosVentaMunicipios"
                    [value]="r.id">
                    {{ r.nombre }}
                </option>
            </select>
        </div>
        <ng-template #noPuntosVentaMunicipios>
            <div></div>
        </ng-template>
    </div>

    <!-- Pregunta 3 -->
    <div class="pregunta-row">
        <p>
            3. ¿Cuántos puntos de venta se localizan en capitales
            departamentales?
        </p>
        <div
            *ngIf="
                registrosPuntosVentaCapitales.length > 0;
                else noPuntosVentaCapitales
            ">
            <select formControlName="puntosVentaCapitales">
                <option
                    *ngFor="let r of registrosPuntosVentaCapitales"
                    [value]="r.id">
                    {{ r.nombre }}
                </option>
            </select>
        </div>
        <ng-template #noPuntosVentaCapitales>
            <div></div>
        </ng-template>
    </div>

    <!-- Pregunta 4 -->
    <div class="pregunta-row">
        <p>4. ¿Cuántas personas trabajan en la empresa?</p>
        <div
            *ngIf="registrosPersonalEmpresa.length > 0; else noPersonalEmpresa">
            <select
                formControlName="personalEmpresa"
                (change)="onPersonalChange($event.target.value)">
                <option
                    *ngFor="let r of registrosPersonalEmpresa"
                    [value]="r.id">
                    {{ r.nombre }}
                </option>
            </select>
        </div>
        <ng-template #noPersonalEmpresa>
            <div></div>
        </ng-template>
    </div>

    <!-- Pregunta 5 -->
    <div class="pregunta-row">
        <p>
            5. ¿Cuántas de estas personas trabajan en el área de ventas,
            almacén, despachos, logística y en la parte administrativa?
        </p>
        <div
            *ngIf="
                registrosClasificacionPersonal.length > 0;
                else noClasificacionPersonal
            ">
            <select formControlName="clasificacionPersonal">
                <option
                    *ngFor="let r of registrosClasificacionPersonal"
                    [value]="r.id">
                    {{ r.nombre }}
                </option>
            </select>
        </div>
        <ng-template #noClasificacionPersonal>
            <div></div>
        </ng-template>
    </div>

    <!-- Pregunta 6 -->
    <div class="pregunta-row">
        <p>
            6. ¿Cuál fue el monto promedio de las ventas mensuales durante el
            año inmediatamente anterior?
        </p>
        <div *ngIf="registrosMontoPromedio.length > 0; else noMontoPromedio">
            <select formControlName="montoPromedio">
                <option *ngFor="let r of registrosMontoPromedio" [value]="r.id">
                    {{ r.nombre }}
                </option>
            </select>
        </div>
        <ng-template #noMontoPromedio>
            <div></div>
        </ng-template>
    </div>

    <!-- Pregunta 7 -->
    <div class="pregunta-row">
        <p>
            7. ¿Qué porcentaje de las ventas indicadas en la pregunta 6 lo
            realizó a otros comercializadores?
        </p>
        <div
            *ngIf="
                registrosPorcentajeVentas.length > 0;
                else noPorcentajeVentas
            ">
            <select formControlName="porcentajeVentas">
                <option
                    *ngFor="let r of registrosPorcentajeVentas"
                    [value]="r.id">
                    {{ r.nombre }}
                </option>
            </select>
        </div>
        <ng-template #noPorcentajeVentas>
            <div></div>
        </ng-template>
    </div>

    <!-- Pregunta 8 -->
    <div class="pregunta-row">
        <p>
            8. ¿Cuántos productos se ofrece en los puntos de venta de su
            empresa? Sin tener en cuenta las diferentes presentaciones, solo el
            producto.
        </p>
        <div
            *ngIf="
                registrosPuntosVentaProductos.length > 0;
                else noPuntosVentaProductos
            ">
            <select formControlName="puntosVentaProductos">
                <option
                    *ngFor="let r of registrosPuntosVentaProductos"
                    [value]="r.id">
                    {{ r.nombre }}
                </option>
            </select>
        </div>
        <ng-template #noPuntosVentaProductos>
            <div></div>
        </ng-template>
    </div>

    <!-- Pregunta 9 -->
    <div class="pregunta-row">
        <p>
            9. Seleccione una o varias opciones de grupos de productos que
            ofrece en sus puntos de venta.
        </p>
    </div>
    <div class="container_tipo_producto">
        <div *ngFor="let opcion of opcionesComercializador; let i = index">
            <span>{{ etiquetaProducto(opcion) }}</span>

            <button
                type="button"
                class="btn_tipo btn_remove"
                *ngIf="!selectedComercializador.includes(opcion)"
                (click)="addComercializador(opcion)">
                ▢
            </button>

            <button
                type="button"
                class="btn_tipo btn_add"
                *ngIf="selectedComercializador.includes(opcion)"
                (click)="removeComercializador(opcion)">
                ▣
            </button>
        </div>
    </div>

    <!-- Mensaje de error si no se selecciona nada -->
    <div
        *ngIf="
            (comercializadorForm.get('comercializador').hasError('required') &&
                comercializadorForm.get('comercializador').touched) ||
            (selectedComercializador.length === 0 &&
                comercializadorForm.get('comercializador').touched)
        ">
        <p class="comercializador_error-checkbox">
            El tipo de comercializador es obligatorio.
        </p>
    </div>

    <div class="contenedor-boton" *ngIf="!caracterizacionBloqueada">
        <button
            (click)="submitForm()"
            class="styles_btn-accept comercializador_btn-enviar">
            Guardar y continuar
        </button>
    </div>
</form>
